"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledEditor = exports.Editor = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));
var _clsx = _interopRequireDefault(require("clsx"));
var _CanvasProvider = require("../../CanvasInterface/CanvasProvider");
var _Canvas = require("../../CanvasInterface/Canvas");
var _Canvas2 = _interopRequireDefault(require("../Canvas/Canvas"));
var _CanvasContainer = _interopRequireDefault(require("../Canvas/CanvasContainer"));
var _StandardToolbox = _interopRequireDefault(require("../StandardToolbox/StandardToolbox"));
var _InlineToolbox = _interopRequireDefault(require("../InlineToolbox/InlineToolbox"));
var _SelectionToolbox = _interopRequireDefault(require("../SelectionToolbox/SelectionToolbox"));
var _Rulers = _interopRequireDefault(require("../Rulers/Rulers"));
var _EditorContainer = _interopRequireDefault(require("./EditorContainer"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Editor = exports.Editor = /*#__PURE__*/function (_React$Component) {
  _inherits(Editor, _React$Component);
  var _super = _createSuper(Editor);
  function Editor() {
    var _this;
    _classCallCheck(this, Editor);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "canvasElementRef", /*#__PURE__*/_react["default"].createRef());
    return _this;
  }
  _createClass(Editor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var canvas = this.props.canvas;
      this.appendView(canvas);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevCanvas = prevProps.canvas;
      var canvas = this.props.canvas;
      if (prevCanvas !== canvas) {
        prevCanvas && this.removeView(prevCanvas);
        this.appendView(canvas);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var canvas = this.props.canvas;
      this.removeView(canvas);
    }
  }, {
    key: "appendView",
    value: function appendView(canvas) {
      canvas.addToContainer(this.canvasElementRef.current);
    }
  }, {
    key: "removeView",
    value: function removeView(canvas) {
      canvas.removeFromContainer();
    }
  }, {
    key: "renderSelectionToolbox",
    value: function renderSelectionToolbox(renderObj) {
      var renderSelectionToolbox = this.props.renderSelectionToolbox;
      if (renderSelectionToolbox) {
        return renderSelectionToolbox(renderObj);
      }
      // render default
      var SelectionToolbox = renderObj.components.SelectionToolbox;
      return /*#__PURE__*/_react["default"].createElement(SelectionToolbox, null);
    }
  }, {
    key: "renderStandardToolbox",
    value: function renderStandardToolbox(renderObj) {
      var renderStandardToolbox = this.props.renderStandardToolbox;
      if (renderStandardToolbox) {
        return renderStandardToolbox(renderObj);
      }
      // render default
      var upload = renderObj.upload,
        StandardToolbox = renderObj.components.StandardToolbox;
      return /*#__PURE__*/_react["default"].createElement(StandardToolbox, {
        upload: upload
      });
    }
  }, {
    key: "renderInlineToolbox",
    value: function renderInlineToolbox(renderObj) {
      var renderInlineToolbox = this.props.renderInlineToolbox;
      if (renderInlineToolbox) {
        return renderInlineToolbox(renderObj);
      }
      // render default
      var InlineToolbox = renderObj.components.InlineToolbox;
      return /*#__PURE__*/_react["default"].createElement(InlineToolbox, null);
    }
  }, {
    key: "renderRulers",
    value: function renderRulers(renderObj) {
      var renderRulers = this.props.renderRulers;
      if (renderRulers) {
        return renderRulers(renderObj);
      }
      // render default
      var Rulers = renderObj.components.Rulers;
      return /*#__PURE__*/_react["default"].createElement(Rulers, null);
    }
  }, {
    key: "render",
    value: function render() {
      var state = this.state,
        props = this.props,
        canvasElementRef = this.canvasElementRef,
        onSizeChange = this.onSizeChange;
      var children = props.children,
        classes = props.classes,
        containerClassName = props.containerClassName,
        upload = props.upload,
        canvas = props.canvas,
        fillContainer = props.fillContainer,
        allowUpScaling = props.allowUpScaling,
        subtractSiblingsHeight = props.subtractSiblingsHeight,
        style = props.style,
        onContainerReady = props.onContainerReady,
        selectedColor = props.selectedColor,
        renderFallback = props.renderFallback,
        onContainerUpdate = props.onContainerUpdate,
        EditorContainer = props.EditorContainer,
        CanvasContainer = props.CanvasContainer,
        CanvasComponent = props.CanvasComponent,
        InlineToolbox = props.InlineToolbox,
        Rulers = props.Rulers,
        SelectionToolbox = props.SelectionToolbox,
        StandardToolbox = props.StandardToolbox,
        renderInCanvasContainer = props.renderInCanvasContainer;
      if (typeof children === 'function') {
        return children({
          canvas: canvas,
          upload: upload,
          state: state,
          classes: classes,
          canvasElementRef: canvasElementRef,
          onSizeChange: onSizeChange,
          fillContainer: fillContainer,
          allowUpScaling: allowUpScaling,
          subtractSiblingsHeight: subtractSiblingsHeight,
          onContainerReady: onContainerReady,
          onContainerUpdate: onContainerUpdate,
          selectedColor: selectedColor,
          containerClassName: containerClassName,
          components: {
            CanvasStateProvider: _CanvasProvider.CanvasStateProvider,
            EditorContainer: EditorContainer,
            CanvasContainer: CanvasContainer,
            CanvasComponent: CanvasComponent,
            InlineToolbox: InlineToolbox,
            Rulers: Rulers,
            SelectionToolbox: SelectionToolbox,
            StandardToolbox: StandardToolbox
          }
        });
      }
      if (!canvas) {
        return renderFallback ? renderFallback() : null;
      }

      // render default
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_CanvasProvider.CanvasStateProvider, {
        canvas: canvas
      }, /*#__PURE__*/_react["default"].createElement(EditorContainer, {
        className: (0, _clsx["default"])(classes.graphicsEditorContainer, containerClassName),
        fillContainer: fillContainer,
        style: style,
        subtractSiblingsHeight: subtractSiblingsHeight,
        allowUpScaling: allowUpScaling,
        onContainerReady: onContainerReady,
        onContainerUpdate: onContainerUpdate,
        selectedColor: selectedColor
      }, /*#__PURE__*/_react["default"].createElement(CanvasContainer, null, /*#__PURE__*/_react["default"].createElement(CanvasComponent, {
        canvasElementRef: canvasElementRef
      }), this.renderInlineToolbox({
        components: {
          InlineToolbox: InlineToolbox
        }
      }), this.renderRulers({
        components: {
          Rulers: Rulers
        }
      }), renderInCanvasContainer && renderInCanvasContainer())), this.renderSelectionToolbox({
        components: {
          SelectionToolbox: SelectionToolbox
        }
      })), this.renderStandardToolbox({
        upload: upload,
        components: {
          StandardToolbox: StandardToolbox
        }
      }));
    }
  }]);
  return Editor;
}(_react["default"].Component);
_defineProperty(Editor, "propTypes", {
  renderStandardToolbox: _propTypes["default"].func,
  renderSelectionToolbox: _propTypes["default"].func,
  renderInlineToolbox: _propTypes["default"].func,
  renderRulers: _propTypes["default"].func,
  renderFallback: _propTypes["default"].func,
  upload: _propTypes["default"].func,
  children: _propTypes["default"].func,
  fillContainer: _propTypes["default"].bool,
  allowUpScaling: _propTypes["default"].bool,
  onContainerReady: _propTypes["default"].func,
  onContainerUpdate: _propTypes["default"].func,
  selectedColor: _propTypes["default"].string,
  EditorContainer: _propTypes["default"].elementType,
  CanvasContainer: _propTypes["default"].elementType,
  CanvasComponent: _propTypes["default"].elementType,
  InlineToolbox: _propTypes["default"].elementType,
  Rulers: _propTypes["default"].elementType,
  SelectionToolbox: _propTypes["default"].elementType,
  StandardToolbox: _propTypes["default"].elementType,
  canvas: _propTypes["default"].instanceOf(_Canvas.AbstractCanvas).isRequired,
  classes: _propTypes["default"].object.isRequired,
  containerClassName: _propTypes["default"].string,
  renderInCanvasContainer: _propTypes["default"].func
});
_defineProperty(Editor, "defaultProps", {
  renderStandardToolbox: null,
  renderSelectionToolbox: null,
  renderInlineToolbox: null,
  renderRulers: null,
  renderFallback: null,
  upload: null,
  children: null,
  fillContainer: false,
  allowUpScaling: false,
  onContainerReady: null,
  onContainerUpdate: null,
  selectedColor: '',
  EditorContainer: _EditorContainer["default"],
  CanvasContainer: _CanvasContainer["default"],
  CanvasComponent: _Canvas2["default"],
  InlineToolbox: _InlineToolbox["default"],
  Rulers: _Rulers["default"],
  SelectionToolbox: _SelectionToolbox["default"],
  StandardToolbox: _StandardToolbox["default"]
});
var StyledEditor = exports.StyledEditor = (0, _withStyles["default"])(_styles["default"], {
  name: 'Designer-Editor'
})(Editor);
var _default = exports["default"] = (0, _CanvasProvider.withCanvas)(StyledEditor);